var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { AsTag } from "../../../common/AsTag";
import classNames from "classnames";
import "./style.css";
var CalloutTitle = function (props) {
    var children = props.children, className = props.className, _a = props.titleAs, titleAs = _a === void 0 ? "h3" : _a, 
    // @ts-ignore
    __TYPE = props.__TYPE, remainingProps = __rest(props, ["children", "className", "titleAs", "__TYPE"]);
    return (React.createElement(AsTag, __assign({ as: titleAs, className: classNames(className, "fr-callout--title", "type-".concat(__TYPE)) }, remainingProps), children));
};
export default CalloutTitle;
